module.exports = __webpack_public_path__ + "static/img/210_TO8_2142_og.e23d3ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/210_TO8_2142_og.jpg
// module id = PKx1
// module chunks = 0